import React from 'react';
import { Step as StepProps } from '@service-victoria/component-library/components/Wizard/props';
import * as Interfaces from 'interfaces';
import { constants } from 'utils';

const Component = React.lazy(() => import('./Done'));

const Step: StepProps<Interfaces.Common.FormValues> = {
  id: 'Done',
  title: constants.Page.title,
  stepName: 'Done',
  Component
};

export { Step };
